var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-stripe-card',{attrs:{"api-key":"pk_live_gLhZiUgcJkSNOaqVY4vsDt1700w2gMlbft"},model:{value:(_vm.source),callback:function ($$v) {_vm.source=$$v},expression:"source"}}),_c('v-btn',{on:{"click":_vm.test}},[_vm._v(" TEST ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }